export const queries = {
  writingDesk: 'writing-desk',
} as const;
